import React, {useState} from "react";
import rightArrowIcon from "../../assets/img/icon_arrow_right.svg";
import personalDataIcon from "../../assets/img/icon_personal_data.svg";
import passwordIcon from "../../assets/img/icon_password.svg";
import moreIcon from "../../assets/img/icon_more.svg";
import {FormattedMessage} from "react-intl";

import {PATH} from "../../routes/routes";
import {removeUserInfoFromStorage} from "../../util/common";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS} from "../../util/Constants";
import backImg from "../../assets/img/icon_back.svg";
import {useNavigate} from "react-router";

function ProfileHome() {
    const navigateTo = useNavigate();
    const userEmail = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    const visible = "visible";
    const hidden = "hidden";
    const [state, setState] = useState({
        confirmLogoutModalStyle: hidden
    });
    const goBack = () => {
        navigateTo(-1);
    }
    const logout = () => {
        removeUserInfoFromStorage();
        navigateTo(-1);
    }

    const openConfirmLogoutModal = () => {
        setState({
            ...state,
            confirmLogoutModalStyle: visible
        })
    }

    const closeConfirmLogoutModal = () => {
        setState({
            ...state,
            confirmLogoutModalStyle: hidden
        })
    }

    return (
        <div className="page-content without-actionsbar">

            <div className={state.confirmLogoutModalStyle + " modal-overlay "}
                 onClick={(e) => closeConfirmLogoutModal()} data-qa="profile-home-confirm-logout-modal"></div>
            <div className="modal">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="DoYouWantToLogoutOutOfYourAccount"/></div>
                </div>
                <br/>
                <div className="row buttons-row">
                    <a className=" btn btn-link btn-md" onClick={() => closeConfirmLogoutModal()} data-qa="profile-home-close-confirm-logout-modal-btn"><FormattedMessage
                        id="Cancel"/></a>
                    <a className=" btn btn-link btn-danger no-underline no-border btn-md"
                       onClick={() => logout()} data-qa="profile-home-logout-btn"><FormattedMessage id="Logout"/></a>
                </div>
            </div>

            <div className="login-container">
                <a className="btn-back" onClick={() => goBack()} data-qa="profile-home-back-btn"><img alt="back button" src={backImg}/></a>


                <div className="login-container-content text-left">
                    <div className="login-container-content-top-text">
                        <FormattedMessage id="MyProfile"/>
                    </div>
                    <div className="quickpick-links">
                        <a className="row link-row" onClick={() => navigateTo(PATH.PROFILE_UPDATE)} data-qa="profile-home-go-to-update-profile-btn">
                            <img src={personalDataIcon}/>
                            <FormattedMessage id="PersonalData"/>
                            <img className="ml-auto" src={rightArrowIcon} alt="right arrow"/>
                        </a>

                        <a className="row link-row" onClick={() => navigateTo(PATH.PROFILE_CHANGE_PASSWORD)} data-qa="profile-home-go-to-change-pwd-btn">
                            <img src={passwordIcon}/>
                            <FormattedMessage id="ChangePassword"/>
                            <img className="ml-auto" src={rightArrowIcon} alt="right arrow"/>
                        </a>

                        <a className="row link-row" onClick={() => navigateTo(PATH.PROFILE_DELETE)} data-qa="profile-home-go-to-profile-delete-btn">
                            <img src={moreIcon}/>
                            <FormattedMessage id="More"/>
                            <img className="ml-auto" src={rightArrowIcon} alt="right arrow"/>
                        </a>

                    </div>

                    <p className="login-info">
                        <FormattedMessage id="LoggedInAs"/>:&nbsp;<span className="email">{userEmail}</span>
                    </p>
                    <a onClick={() => openConfirmLogoutModal()} className="link logout-link underlined" data-qa="profile-home-open-logout-confirmation-modal-btn">
                        <FormattedMessage
                            id="Logout"/></a>
                </div>
            </div>
        </div>

    );
}

export default ProfileHome;
